if(!customElements.get('internal-navigation')) {
  class InternalNavigation extends HTMLElement {
    static observedAttributes = ["active-section"];

    constructor() {
      super();

      this.elLinks = this.querySelectorAll('[data-link]');
      this.elSections = [...this.elLinks].map(el => {
        return document.getElementById(el.href.split('#')[1]);
      })

      this.scrollY = window.scrollY;
      this.scrollTicking = false;
      this.scrolling = false;
      this.activeSection = null;
      this.observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          this.parentNode.classList.toggle('footer-visible', entry.isIntersecting)
        });
      });

      setTimeout(() => this.setActiveSection());
      document.addEventListener('scroll', this.scrollMethod.bind(this));
      this.observer.observe(document.querySelector('footer'));
    }

    scrollMethod() {
      this.scrollY = window.scrollY;

      if (!this.scrollTicking) {
        window.requestAnimationFrame(() => {
          this.setActiveSection();
          this.scrollTicking = false;
        });
        this.scrollTicking = true;
      }
    }

    setActiveSection() {
      this.elSections.forEach((el, index) => {
        const { offsetTop: top, offsetHeight: height } = el;
        const elNextSection = this.elSections[index + 1];
        const documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
        const bottom = elNextSection ? elNextSection.offsetTop : documentHeight;
        
        if(this.scrollY >= (top - height) && this.scrollY <= bottom) {
          this.setAttribute('active-section', el.id);
        }
      })
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if(name == 'active-section') {
        let activeIndex = this.elSections.map(el => el.id).indexOf(newValue);
        this.activeSection = newValue;
        this.style.setProperty('--active', activeIndex > 0 ? activeIndex : 0);
        this.elLinks.forEach(el => {
          let isActive = el.href.split('#')[1] == this.activeSection;
          isActive ? el.classList.add('active') : el.classList.remove('active');
        })
      }
    }

  }
  customElements.define('internal-navigation', InternalNavigation);
}